export const typeOfBulkIdRegisterModal = 'typeOfBulkIdRegisterModal';
export const BULK_ID_MODAL_REDUCER_KEY = 'BulkIdRegisterModal';
export const SET_STATUS = 'BulkIdRegisterModal/SET_STATUS';
export class BulkIdRegisterModalStatus {
  static INITIAL = 'INITIAL';

  static LOADING = 'LOADING';

  static SUCCESS = 'SUCCESS';

  static NOT_FOUND = 'NOT_FOUND';

  static ERROR = 'ERROR';
}
